export default __webpack_public_path__ + "static/wwu-1-027033bfdc045dcd1101a9edd4ce5b9b.png";